import { memo } from 'react';
import { RankedTester, rankWith, scopeEndsWith, WithClassname } from '@jsonforms/core';
import { TranslateProps, withJsonFormsOneOfEnumProps, withTranslateProps } from '@jsonforms/react';
import SelectFactoryConfigurationControl from './renderer';

export const MaterialEnumCell = (props: any & WithClassname & TranslateProps) => (
  <SelectFactoryConfigurationControl {...props} />
);

export const SelectFactoryConfigurationTester: RankedTester = rankWith(
  1000,
  scopeEndsWith('select_factory_to_copy_configuration_from')
);

export default withJsonFormsOneOfEnumProps(withTranslateProps(memo(MaterialEnumCell)), false);
